export const ALL_EXTENT: Record<string, [number, number, number, number]> = {
  安徽: [114.878463, 29.395191, 119.645188, 34.65234],
  澳门: [113.528164, 22.109142, 113.598861, 22.217034],
  北京: [115.416827, 39.442078, 117.508251, 41.058964],
  福建: [115.84634, 23.500683, 120.722095, 28.317231],
  甘肃: [92.337827, 32.596328, 108.709007, 42.794532],
  广东: [109.664816, 20.223273, 117.303484, 25.519951],
  广西: [104.446538, 20.902306, 112.05675, 26.388528],
  贵州: [103.599417, 24.620914, 109.556069, 29.224344],
  海南: [108.614575, 8.30204, 117.842823, 20.16146],
  河北: [113.454863, 36.048718, 119.84879, 42.615453],
  河南: [110.35571, 31.3844, 116.644831, 36.366508],
  黑龙江: [121.183134, 43.422993, 135.088511, 53.560901],
  湖北: [108.362545, 29.032769, 116.132865, 33.272876],
  湖南: [108.786106, 24.643089, 114.256514, 30.1287],
  吉林: [121.638964, 40.864207, 131.309886, 46.302152],
  江苏: [116.355183, 30.76028, 121.927472, 35.127197],
  江西: [89.551219, 8.972204, 124.57284, 40.256391],
  辽宁: [118.839668, 38.72154, 125.785614, 43.488548],
  内蒙古: [97.17172, 37.406647, 126.065581, 53.333779],
  宁夏: [104.284332, 35.238497, 107.661713, 39.387783],
  青海: [89.401764, 31.600668, 103.068897, 39.212599],
  山东: [114.810126, 34.377357, 122.705605, 38.399928],
  山西: [110.230241, 34.583784, 114.56294, 40.744953],
  陕西: [105.488313, 31.706862, 111.241907, 39.582532],
  上海: [120.852326, 30.691701, 122.118227, 31.874634],
  四川: [97.347493, 26.048207, 108.54257, 34.315239],
  台湾: [119.314417, 21.896939, 123.701571, 25.938831],
  天津: [116.702073, 38.554824, 118.059209, 40.251765],
  西藏: [78.386053, 26.853453, 99.115351, 36.484529],
  香港: [113.815684, 22.134935, 114.499703, 22.566546],
  新疆: [73.501142, 34.336146, 96.384783, 49.183097],
  云南: [97.527278, 21.142312, 106.196958, 29.225286],
  浙江: [118.022574, 26.643625, 122.834203, 31.182556],
  重庆: [110.195637, 28.164706, 105.289838, 32.204171],
  japan: [122.56, 20.25, 153.59, 45.31],
};
